import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import PageWithSidebar from 'components/PageWithSidebar';
import EntitySidebar from 'components/EntitySidebar';
import Tabber from 'components/Tabber';
import SeoTab from 'components/SeoTab';
import PageEditForm from 'components/PageEditForm';

import { withData } from 'lib';
import { ContentPageEditPageQuery } from '__generated__/ContentPageEditPageQuery.graphql';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';

const query = graphql`
  query ContentPageEditPageQuery($id: ID!) {
    page(id: $id) {
      name

      ...SeoTab_seoable
      ...EntitySidebar_entity
      ...PageEditForm_page
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ContentPageEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/content', name: 'Turinys' },
  { link: '/content/pages', name: 'Puslapiai' },
];

const ContentPageEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { page } = usePreloadedQuery<ContentPageEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!page) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={page} />}
      breadcrumbs={[...breadcrumbs, { name: page!.name }]}>
      <Tabber
        tabs={[
          {
            title: 'Bendra informacija',
            component: <PageEditForm page={page} />,
            hash: 'main',
          },
          {
            title: 'SEO',
            component: <SeoTab type="PAGE" seoable={page} />,
            hash: 'seo',
          },
        ]}
      />
    </PageWithSidebar>
  );
};

export default withData<ContentPageEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(ContentPageEditPage);
